import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-app_icon-24",
  "use": "icon-app_icon-24-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"icon-app_icon-24\"><g><path d=\"M32 9a2 2 0 012 2v20a2 2 0 01-2 2H4a2 2 0 01-2-2V11a2 2 0 012-2h28zm-6.5 16h-15a1.5 1.5 0 000 3h15a1.5 1.5 0 000-3z\" /><path d=\"M9 14V8a4 4 0 014-4h10a4 4 0 014 4v6\" stroke-opacity=\".6\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"3\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol